// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c5dac542","443":"b5a727c9","453":"a4ac56b2"}[chunkId] + ".chunk.js";
};